import {Utils} from '../../common/scripts/utils.js';

class ProjectCard {
    constructor(options) {
        this.card = options.card;
        this.showMore = this.card.querySelector('.j-project-more');
        this.close = this.card.querySelector('.j-project-close');
        this.wrapper = this.card?.querySelector('.j-project-card-about');
        this.nextBtnPage = this.wrapper?.querySelector('.j-about-next');
        this.prevBtnPage = this.wrapper?.querySelector('.j-about-prev');
        this.slides = this.wrapper?.querySelectorAll('.j-project-slide');
    }

    init() {
        this._bindEvents();
    }

    _bindEvents() {
        if (this.nextBtnPage) {
            this.nextBtnPage.addEventListener('click', () => {
                this._translateSlides(this.nextBtnPage, 'next');
            });
        }

        this.prevBtnPage?.addEventListener('click', () => {
            this._translateSlides(this.prevBtnPage, 'prev');
        });

        this.showMore?.addEventListener('click', () => {
            this._displayMore();
        });

        this.close?.addEventListener('click', () => {
            this._displayMore();
        });
    }

    /**
     * Отображает / скрывает дополнительную информацию о проекте
     */
    _displayMore() {
        if (Utils.getWindowWidth() > 1279.95) {
            this.showMore.classList.toggle('is-active');
            this.wrapper.classList.toggle('is-active');
        }
    }

    /**
     *
     * @param {object} elem - Кнопка которую нажали.
     * @param {string} direction - Направление прокрутки (влево или вправо)
     *
     * Проверяем если у нажатой кнопки нет активного статуса то листаем видимую область в зависимости от направления
     */
    _translateSlides(elem, direction) {
        if (!elem.classList.contains('is-active')) {
            return;
        }

        const length = direction === 'next' ? '-70%' : '10%';

        this.prevBtnPage.classList.toggle('is-active');
        this.nextBtnPage.classList.toggle('is-active');

        this.slides.forEach((slide) => {
            slide.style.transform = `translateX(${length})`;
        });
    }
}

export default ProjectCard;
